<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0"
      >
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Competitors</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
                <p>The map displays up to 250 competitors closest to the market center-point in the selected industry market.
                   Data tables, charts and associated business contact lists linked to this report include all competitors in
                   the selected industry market area, not only those which are represented on the map.
                </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div
          class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0 mt-4"
        >
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Map/Companies" md-icon="location_on" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>
                          Industry Locations
                          <p class="m-0 pt-2">
                            {{ release_display }} Industry Market Area
                            Operations (up to 250 closest in market area)
                          </p>
                          <!-- <div class="card-icon">
                                <md-icon>location_on</md-icon>
                            </div>
                            <div>
                              <h4 class="title text-left">Industry Locations</h4>
                              <p>{{release_display}} Industry Market Area Operations
                                (up to 250 closest in market area)
                              </p>
                          </div>-->
                        </md-card-header>
                        <md-card-content class="new_market_main">
                          <div class="md-layout new_market_content industry_map">
                            <div class="md-layout-item md-medium-size-100 md-size-100">
                              <div class="md-layout px-4 mt-4">
                                <div class="md-layout-item md-medium-size-100 md-size-35">
                                  <p>
                                    The map displays up to 250 competitors closest to the market center-point in the selected industry market. Data tables, charts and associated business contact lists linked to this report include all competitors in the selected industry market area, not only those which are represented on the map.
                                  </p>
                                  <ul class="favorite-list companis-list-tabl competitors-list">
                                    <li
                                      v-for="(location, index) in locations"
                                      :key="index"
                                      class="favorite-list-item map-content p-0"
                                    >
                                      <collapse
                                        :collapse="[
                                          `#${index + 1} ${location.CONAME}`,
                                        ]"
                                        icon="keyboard_arrow_down"
                                        idPrefix="mapHref_"
                                        color-collapse="info"
                                        value="left"
                                        class="map-markers"
                                        @setMarker="setMarker"
                                        :active="false"
                                      >
                                        <template slot="md-collapse-pane-1">
                                          <ul class>
                                            <li>
                                              <h6>
                                                <i class="md-icon">map</i>Map:
                                              </h6>
                                              <p>#:{{ index + 1 }}</p>
                                              <h6>
                                                <i class="md-icon">place</i>Address:
                                              </h6>
                                              <p>
                                                {{ location.ADDR }},
                                                {{ location.CITY16 }},
                                                {{ location.ZIP4 }}
                                              </p>
                                            </li>
                                            <li>
                                              <h6>
                                                <i class="md-icon">near_me</i>Distance:
                                              </h6>
                                              <p>
                                                {{ location.dist_short }} miles
                                                from market center-point
                                              </p>
                                              <h6>
                                                <i class="md-icon">equalizer</i>Sales Bracket:
                                              </h6>
                                              <p>{{ location.sales_bracket }}</p>
                                            </li>
                                            <li>
                                                  <h6>
                                                    <i class="md-icon">price_change</i>Est. Value:
                                                  </h6>
                                                  <p>
                                                    {{
                                                      location.value_bracket
                                                    }}

                                                  </p>
                                                  <h6>
                                                    <i class="md-icon">language</i>Website:
                                                  </h6>
                                                  <p>
                                                    {{
                                                      location.URLOT1
                                                    }}
                                                  </p>
                                                </li>
                                            <!-- <p>Map #:{{index + 1}}</p>
                                                  {{ location.ADDR }} <br>
                                                  {{ location.CITY16 }}, {{ location.ZIP4 }} <br>
                                                  {{ location.dist_short }} miles from market center-point <br>
                                            Sales Bracket: {{ location.sales_bracket }}</p>-->
                                          </ul>
                                        </template>
                                      </collapse>
                                    </li>
                                  </ul>
                                </div>
                                <div class="md-layout-item md-medium-size-100 md-size-65">
                                  <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div> -->
                                  <div class="md-card-content competitors-map border-0">
                                    <google-map-loader
                                      ref="mapRef"
                                      :locations="mapData"
                                      :center="mapCenter"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 px-4 mt-4"
                                >
                                   <md-card class="md-card-profile ">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Competitive Market Narrative
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100"
                                    >
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4> -->
                                        <p>
                                          {{cmnText.competitors}}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                                </div>
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 px-4 mt-4"
                                >
                                  <md-card class="md-card-profile">
                                    <md-card-header>
                                      <h4 class="title m-0">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                        >
                                          <md-icon class="color-white">article</md-icon> Competitors
                                        </div>
                                      </h4>
                                    </md-card-header>
                                    <md-card-content>
                                      <div class="md-layout">
                                        <div class="md-layout-item md-medium-size-100 md-size-100">
                                          <div class="extra_space">
                                            <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                            </h4>-->
                                            <p>
                                              How many industry competitors are in this market?
                                              This section analyzes the industry population in your market area.
                                              Total industry sites are the sum of firms plus branches.
                                              Small businesses are single firms within 25 employees or less.
                                              Startups have been in operation for less than two years.
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
                <md-tab md-label="Table" md-icon="window">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Table</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100 blue-tbl">
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Industry Market Area Operations</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Industry Market Area Operations</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table border-0 p-0"
                                    >
                                      <md-table
                                        v-model="tableDataMarketArea"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell md-label>
                                            <div class="md-table-side-label">{{ item.name }}</div>
                                          </md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.firms
                                            )"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.firms[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50 rprt-chrt">
                              <md-card class="md-card-profile">
                                <md-card-content>
                                  <chart-card
                                    header-animation="false"
                                    :chart-data="colouredLineChart.data"
                                    :chart-options="colouredLineChart.options"
                                    chart-type="Line"
                                    header-icon
                                    chart-inside-content
                                    no-footer
                                    background-color="blue"
                                  >
                                    <template slot="chartInsideHeader">
                                      <h4 class="title m-0">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                        >
                                          {{ years[years.length - 1] }} Industry Market Area
                                          Operations
                                        </div>
                                      </h4>
                                      <!-- <h4 class="title">Mar-2021 Industry Market Area Operations</h4> -->
                                    </template>
                                  </chart-card>
                                  <div class="pie-line">
                                      <ul>
                                        <li><span class=""><i class="fa fa-square sky-blue-color"></i></span> Industry Sites</li>
                                         <li><span class=""><i class="fa fa-square blue-color"></i></span> Firms</li>
                                          <li><span class=""><i class="fa fa-square yellow-color"></i></span> Small Business</li>
                                          <li><span class=""><i class="fa fa-square green-color"></i></span> Startups</li>
                                          <li><span class=""><i class="fa fa-square red-color"></i></span> Branches</li>
                                      </ul>
                                    </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-50 md-size-50">
                              <md-card class="md-card-profile px-4">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Competitors
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                          How many industry competitors are in this market?
                                          This section analyzes the industry population in your market area.
                                          Total industry sites are the sum of firms plus branches.
                                          Small businesses are single firms within 25 employees or less.
                                          Startups have been in operation for less than two years.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from '@/components';
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import GoogleMapLoader from '@/pages/Dashboard/Components/GoogleMapLoader';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    Collapse,
    GoogleMapLoader,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataMarketArea: [],

      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      tableData: [],
    };
  },
  computed: {
    ...mapState({
      locations: (state) => state.user.market_report.data['mapDataVestimate'] ?
        state.user.market_report.data['mapDataVestimate'].filter(x => x.lat !== null && x.lng !== null)
        : null,
      mapData: (state) =>
        state.user.market_report.data['mapData']['real-time']['map_data'][
        'data'
        ],
      mapCenter: (state) =>
        state.user.market_report.data['mapData']['real-time']['map_center'][
        'data'
        ],
      years: (state) => state.user.market_report.data['years'],
      competitors: (state) => state.user.market_report.data.data['competitors'],
      release_display: (state) =>
        state.user.market_report.data.general['release_display'],
      cmnText: (state) =>state.user.market_report.cmnText,
    }),
  },
  mounted() {
    this.tableDataMarketArea = Object.entries(
      this.competitors
    ).map(([table, data]) => ({ name: table, firms: Object.values(data) }));
    this.colouredLineChart.data = {
      labels: this.years,
      series: this.tableDataMarketArea.map((item) => ({
        name: item.name,
        data: item.firms,
      })),
    };
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    setMarker(index) {
      let markers = this.$refs.mapRef.markers;
      let marker = markers[index - 1];
      this.$refs.mapRef.BounceMarker(marker, 750);
      this.$refs.mapRef.infowindow.setContent(marker.info);
      this.$refs.mapRef.infowindow.open(marker.getMap(), marker);
    },
  },
};
</script>
<style lang="scss">
.md-collapse-label {
  padding: 0;
}
.competitors-list .md-collapse {
  border-top: 1px solid #eee;
}
.competitors-list li.favorite-list-item {
  padding: 0;
}
#google-map {
  height: 500px !important;
}
.new_market_main {
  padding-right: 0;
  padding-left: 0;
  .new_market_content {
    padding-right: 0;
    padding-left: 0;
    .md-layout-item {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
